import type { SuggestionOptions } from "@tiptap/suggestion";
import tippy from "tippy.js";
import CommandList from "./CommandList.svelte";

const suggestion = (): Partial<SuggestionOptions> => {
  return {
    render: () => {
      let component: CommandList | null;
      let popup: any[];

      return {
        onStart: (props) => {
          const el = document.createElement("div");
          component = new CommandList({
            props,
            target: el,
          });

          if (!props.clientRect) {
            return;
          }

          // @ts-ignore - incorrect typing https://github.com/ueberdosis/tiptap/issues/2795
          popup = tippy("body", {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: el,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
          });
        },

        onUpdate(props) {
          component?.$set(props);

          if (!props.clientRect) {
            return;
          }

          popup[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onKeyDown(props) {
          if (props.event.key === "Escape") {
            popup?.[0].hide();

            return true;
          }

          return false;
        },

        onExit() {
          popup?.[0].destroy();
          component?.$destroy();
        },
      };
    },
  };
};

export default suggestion;
